"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyrightInfoApi = copyrightInfoApi;
exports.saveCrmebCopyRight = saveCrmebCopyRight;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 获取版权信息
 */
function copyrightInfoApi() {
  return (0, _request.default)({
    url: '/admin/platform/copyright/get/info',
    method: 'get'
  });
}

/**
 * 保存版权信息
 */
function saveCrmebCopyRight(data) {
  return (0, _request.default)({
    url: '/admin/platform/copyright/update/company/info',
    method: 'post',
    data: data
  });
}